import { useState } from 'react'

import { Flex, Spinner } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export const Writer = ({ sendMessage = false }) => {
  const [currentMessage, setCurrentMessage] = useState('')
  const [sending, setSending] = useState(false)

  const onSend = async () => {
    if (!currentMessage && !currentMessage.length) return
    setSending(true)
    setCurrentMessage('')
    sendMessage(currentMessage)
    setSending(false)
  }

  return (
    <Flex
      style={{
        background: 'var(--surface-2)',
        borderTop: '1px solid var(--border)',
        borderBottomLeftRadius: 'var(--radius-lg)',
        borderBottomRightRadius: 'var(--radius-lg)',
        height: 70
      }}
      row
      fw
      js
    >
      <FieraComposer
        update={setCurrentMessage}
        send={onSend}
        currentMessage={currentMessage}
        sending={sending}
      />
    </Flex>
  )
}

const FieraComposer = ({ update, send, currentMessage, sending }) => {
  const handleKeypress = (sendFn) => (e) => {
    if (e.code === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendFn()
    }
  }

  return (
    <Flex fw row style={{ alignItems: 'center', padding: '0 12px', gap: 8 }}>
      <textarea
        placeholder={t.mcScriviMessaggio}
        id="textAreaFiera"
        style={{
          padding: '10px 12px',
          fontSize: 14,
          resize: 'none',
          height: 44,
          border: '1px solid var(--border-strong)',
          borderRadius: 'var(--radius-md)',
          background: 'var(--surface)',
          color: 'var(--ink-900)',
          width: '100%',
          outline: 'none',
          fontFamily: 'var(--font-family)'
        }}
        value={currentMessage}
        autoFocus
        onChange={(e) => update(e.target.value)}
        onKeyPress={handleKeypress(send)}
      />
      {sending ? (
        <Flex style={{ height: 40, width: 40, flexShrink: 0 }}>
          <Spinner />
        </Flex>
      ) : (
        <button
          type="button"
          className="nbtn nbtn--primary nbtn--icon"
          style={{ borderRadius: '50%', width: 40, height: 40, flexShrink: 0 }}
          onClick={send}
        >
          <i className="pi pi-send" style={{ fontSize: 14 }} />
        </button>
      )}
    </Flex>
  )
}
